/*
 * @Author: Ashley.Liu
 * @Date: 2022-05-09 14:11:39
 * @LastEditTime: 2022-07-08 19:13:42
 * @Description: desc
 */
import store from '@/store/'
import router from '@/plugins/router'
export function getAllDicts (isRefresh) {
  if (isRefresh && router.history.current.path === '/login') {
    return
  }
  getTooltipsDict()
  getTopicsDict()
  getUsersDict()
  getTagsDict()
}

export function getTooltipsDict () {
  const tooltips = store.state.dictionarys.tooltipsDict
  if (!tooltips || (Object.prototype.toString.call(tooltips) === '[object Object]' && !Object.keys(tooltips).length)) {
    store.dispatch('dictionarys/getTooltipsDict')
  }
  return store.state.dictionarys.tooltipsDict
}

export function getTopicsDict () {
  if (!store.state.dictionarys.topicsDict?.length) {
    store.dispatch('dictionarys/getTopicsDict')
  }
  return store.state.dictionarys.topicsDict
}
export function getUsersDict () {
  if (!store.state.dictionarys.usersDict?.length) {
    store.dispatch('dictionarys/getUsersDict')
  }
  return store.state.dictionarys.usersDict
}
export function getTagsDict () {
  if (!store.state.dictionarys.tagsDict?.length) {
    store.dispatch('dictionarys/getTagsDict')
  }
  return store.state.dictionarys.tagsDict
}
